import { datajs, datajsAll } from '../shared/utils';
import Swiper, { FreeMode, Navigation } from 'swiper';

export default class PromoCarousel {
	static init() {
		const promoCarousels = datajsAll('promo-carousel');

		if (promoCarousels.length === 0) {
			return;
		}

		promoCarousels.forEach((carousel) => {
			this.setupSwiperInstance(carousel);
		});
	}

	static setupSwiperInstance(carousel) {
		let throttled = false;
		const block = carousel.closest('[data-js~=latest-news]');
		const contentCol = datajs('content-col', block);

		// eslint-disable-next-line no-new
		new Swiper(carousel, {
			modules: [FreeMode, Navigation],
			speed: 500,
			slidesPerView: 'auto',
			freeMode: true,
			spaceBetween: 16,

			navigation: {
				nextEl: '[data-js~=carousel-next]',
				prevEl: '[data-js~=carousel-prev]',
			},

			on: {
				reachBeginning: function () {
					block.classList.remove('is-fromEdge');
				},

				fromEdge: function () {
					block.classList.add('is-fromEdge');
					if (contentCol) {
						block.style.setProperty('--content-col-width', (contentCol.offsetWidth || 0) / 16 + 'rem');
					}
				},
			},
		});

		if (contentCol) {
			const updateCssVars = () => {
				block.style.setProperty('--content-col-width', (contentCol.offsetWidth || 0) / 16 + 'rem');
			};

			// Throttled Resize handler
			window.addEventListener(
				'resize',
				function () {
					if (!throttled) {
						updateCssVars();
						throttled = true;
						setTimeout(function () {
							throttled = false;
						}, 100);
					}
				},
				{
					capture: false,
					passive: true,
				}
			);

			updateCssVars();
		}
	}
}
